import { createContext, useContext, useRef } from "react";

/** Inactive document tabs stay mounted for undo/redo, but must not handle global shortcuts. */
export const EditorActivity = createContext(true);
export function useEditorActiveRef() {
  const active = useContext(EditorActivity);
  const ref = useRef(active);
  ref.current = active;
  return ref;
}
